import {forwardRef, useRef, useState} from 'react'

import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert';

import Dialog from "@base/Dialog";
import Toast from "../../base/Toast";
import AuthorizedFunction from '@security/AuthorizedFunction'

export const ObjetoPostalNaoExistenteDialog = forwardRef((props, ref) => {

  const [open, ] = useState(props.aberto ?? false);
  const toastRef = useRef(null);

  return (
    <>
      <Toast ref={toastRef}/>
      <Dialog
        maxWidth={'sm'}
        fullWidth={true}
        closeDialog={props.aoFechar}
        openDialog={open}
        title='Importante!'
      >
        <Grid container>
          <Grid item sm={12}>
            <Alert severity="warning">O Objeto Postal "{props.objetoPostal}" não passou pela etapa de recebimento! 
              
              {!AuthorizedFunction(["__processo.usuario.administrador"])  && (
              <> Por favor entre em contato com o seu supervisor para registrar o recebimento.</>
              )}
            
            </Alert>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
})

export default ObjetoPostalNaoExistenteDialog;
